import { Grid, Panel, Row } from '@indoqa/style-system';
import * as React from 'react';
import { withUIETheme } from '../uietheme/withUIETheme';
import { FontMixContent } from './FontMixContent';
import { FontStylePanel } from './FontStylePanel';
const FontMixPanelInternal = ({ fontSizes, textFontSize, fontMix }) => {
    const { name, textFont, headlineFont } = fontMix;
    return (React.createElement(Grid, { spacing: "1rem", fullWidth: true },
        React.createElement(Row, null,
            React.createElement(Panel, null,
                React.createElement(FontStylePanel, { name: name },
                    React.createElement(FontMixContent, { textFont: textFont, headlineFont: headlineFont, fontSizes: fontSizes, textFontSize: textFontSize }))))));
};
export const FontMixPanel = withUIETheme(FontMixPanelInternal);
//# sourceMappingURL=FontMixPanel.js.map